import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/CommercialInvoice/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Commercial Invoice</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            If there is one document that can make or break your shipment’s timeline, it’s the Commercial
            Invoice. Think of it as the passport for your cargo. When goods cross borders, customs officers,
            carriers, and bankers all look at this single piece of paper to decide what happens next. For
            freight forwarders, getting this right isn't just about compliance, it's about avoiding the
            nightmare of your container getting stuck at the port while storage fees pile up.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;